<p *ngFor="let alert of alerts.alerts">
    <ngb-alert [type]="alert.type" (close)="alert.close()">{{ alert.message }}</ngb-alert>
</p>